
import { getUser } from "./CommonGetters"

export const isUserLoggedIn = () => {
  const user = getUser()
  return typeof user === "object"
}
